export default "__VITE_ASSET__DWDonZGr__"